module.exports = __webpack_public_path__ + "static/media/iconRefresh2.36e2e78a.svg";